import React from "react"
import { Col, FormGroup, InputGroup, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"

const ProductStock = (props: any) => {
    const { data, setData, type, onlyView, handleChangeInput, category, brand, origin, validation } = props

    return (
        <PageBody>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="nutri-title mb-3">Cấu hình định mức tồn</div>
                <ToggleButton isDisabled={type == 'view' ? true: false} elmChecked={data?.stock_status == 1 ? true : false} data={data} setData={(data:any) => {setData(data)}} name='stock_status' />
            </div>
            {data?.stock_status == 1 &&
            <Row>
                <Col md={6} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Tồn tối thiểu</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({target:{ name: "stock_min" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'stock_min'} type={'text'} className="form-control" 
                                value={type === 'view' && !data?.stock_min ? '---': data?.stock_min}
                                placeholder={(type=='view' && !data?.stock_min) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                            {validation?.stock_min &&<div className="invalid-feedback d-block" >{validation?.stock_min}</div>}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Tồn tối đa</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({target:{ name: "stock_max" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'stock_max'} type={'text'} className="form-control" 
                                value={type === 'view' && !data?.stock_max ? '---': data?.stock_max}
                                placeholder={(type=='view' && !data?.stock_max) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                            {validation?.stock_max &&<div className="invalid-feedback d-block" >{validation?.stock_max}</div>}
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>}
        </PageBody>
    )
}

export default ProductStock